import CryptoJS from "crypto-js";
import { Buffer } from "buffer";
import crypto from "crypto";
import { CRYPTO_SECRET_KEY } from "./constants/app";

export const decryptCredentials = (value = "") => {
  if (!value) {
    return "";
  }
  const rawData = Buffer.from(value, "base64").toString("hex");
  const ciphertext = CryptoJS.enc.Hex.parse(rawData);
  const pwhash = CryptoJS.SHA1(CryptoJS.enc.Utf8.parse(CRYPTO_SECRET_KEY));
  const key = CryptoJS.enc.Hex.parse(
    pwhash.toString(CryptoJS.enc.Hex).substring(0, 32)
  );
  const decryptBytes = CryptoJS.AES.decrypt(
    {
      ciphertext,
    },
    key,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return decryptBytes.toString(CryptoJS.enc.Utf8);
};

export function encryptAES256(text, masterkey) {
  const iv = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv("aes-256-gcm", masterkey, iv);
  const encrypted = Buffer.concat([
    cipher.update(text, "utf8"),
    cipher.final(),
  ]);
  const tag = cipher.getAuthTag();
  return Buffer.concat([iv, encrypted, tag]).toString("base64");
}
